export const getSubscriptionsEnabled = (tenant) =>
  !!(tenant?.subscriptons_enabled ?? tenant?.subscriptions_enabled);

export const isSubscriptionsSlaEligible = (slaLevel) => {
  const normalized = String(slaLevel || "").trim().toLowerCase();
  return normalized === "business" || normalized === "gold";
};

export const isSubscriptionFeatureLocked = (tenant, slaLevel) =>
  !isSubscriptionsSlaEligible(slaLevel) || !getSubscriptionsEnabled(tenant);

export const EXISTING_USERS_HANDLING = {
  LEGACY: "legacy",
  SUBSCRIPTION: "subscription",
};

export const isLegacyWlSubUser = (user) =>
  !!user?.is_sub_user &&
  String(user?.wl_user_type || "").toLowerCase() === EXISTING_USERS_HANDLING.LEGACY;

export const canSubUserManageSubscription = (user, tenant) =>
  getSubscriptionsEnabled(tenant) &&
  !!user?.is_sub_user &&
  !isLegacyWlSubUser(user);
